import CustomPagination from '@/platform/common/components/CustomPagination/CustomPagination';
import NoDataRow from '@/platform/common/components/NoDataRow/NoDataRow';
import {
    Button,
    Container,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Segment,
    SegmentContent,
    SegmentFooter,
    SegmentHeader,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '@/platform/ui';
import {
    EllipsisVerticalIcon,
    PencilIcon,
    PlusIcon,
} from '@heroicons/react/24/outline';
import { Link, usePage } from '@inertiajs/react';
import Navigation from '../components/Navigation';

const IndexView = () => {
    const { auth, questions } = usePage().props;

    return (
        <Container>
            <Navigation />

            <Segment>
                <SegmentHeader header='Vragen'>
                    {auth.permissions.includes('update questionnaires') && (
                        <Button
                            variant='primary'
                            as={Link}
                            href='/questionnaires/questions/create'
                        >
                            <PlusIcon className='size-5' />
                            Nieuwe vraag
                        </Button>
                    )}
                </SegmentHeader>

                <SegmentContent>
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHeaderCell>
                                    Standaard vraag
                                </TableHeaderCell>
                                <TableHeaderCell textAlign='center'>
                                    Vertalingen
                                </TableHeaderCell>
                                <TableHeaderCell textAlign='right' />
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {questions?.meta?.total === 0 && (
                                <NoDataRow numberOfColumns={3} />
                            )}

                            {questions?.data?.map(question => (
                                <TableRow key={question.id}>
                                    <TableCell>
                                        {question?.question['nl'] || ''}
                                    </TableCell>
                                    <TableCell textAlign='center'>
                                        {Object.keys(question.question)
                                            ?.filter(lang => lang !== 'nl')
                                            ?.map(lang => (
                                                <Tooltip key={lang}>
                                                    <TooltipTrigger>
                                                        <img
                                                            src={`/flags/4x3/${lang === 'en' ? 'gb' : lang}.svg`}
                                                            alt={lang}
                                                            className='size-6'
                                                        />
                                                    </TooltipTrigger>
                                                    <TooltipContent side='left'>
                                                        {
                                                            question.question[
                                                                lang
                                                            ]
                                                        }
                                                    </TooltipContent>
                                                </Tooltip>
                                            ))}
                                    </TableCell>
                                    <TableCell textAlign='right'>
                                        {auth.permissions?.includes(
                                            'update questionnaires'
                                        ) && (
                                            <Menu>
                                                <MenuButton>
                                                    <EllipsisVerticalIcon className='size-5' />
                                                </MenuButton>
                                                <MenuItems anchor='bottom end'>
                                                    <MenuItem
                                                        as={Link}
                                                        href={`/questionnaires/questions/${question.id}/edit`}
                                                        icon={PencilIcon}
                                                    >
                                                        Wijzigen
                                                    </MenuItem>
                                                </MenuItems>
                                            </Menu>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </SegmentContent>

                <SegmentFooter>
                    <CustomPagination
                        meta={questions?.meta}
                        only={['questions']}
                    />
                </SegmentFooter>
            </Segment>
        </Container>
    );
};

export default IndexView;
